const PARTIAL_ELIGIBLE_BACKEND_STATUSES = ["In transit", "Delayed"] as const;

export type OverviewShipmentStatusDisplay =
  | {
      kind: "partial";
      deliveredCount: number;
      totalCount: number;
    }
  | {
      kind: "backend";
    };

type DeliveryStopProgressInput = {
  delivered_at: string | null | undefined;
};

export function resolveOverviewShipmentStatusDisplay(args: {
  isMultistop: boolean;
  backendStatus: string | null | undefined;
  stops: DeliveryStopProgressInput[] | undefined;
}): OverviewShipmentStatusDisplay {
  const { isMultistop, backendStatus, stops } = args;

  if (!isMultistop) {
    return { kind: "backend" };
  }

  if (
    !backendStatus ||
    !PARTIAL_ELIGIBLE_BACKEND_STATUSES.includes(
      backendStatus as (typeof PARTIAL_ELIGIBLE_BACKEND_STATUSES)[number],
    )
  ) {
    return { kind: "backend" };
  }

  if (!stops?.length) {
    return { kind: "backend" };
  }

  const deliveredCount = stops.filter((stop) => Boolean(stop.delivered_at)).length;
  const totalCount = stops.length;

  if (deliveredCount > 0 && deliveredCount < totalCount) {
    return { kind: "partial", deliveredCount, totalCount };
  }

  return { kind: "backend" };
}
